import { useQueries } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getAuthAccess } from 'src/api/queries';
import Forbidden from '../../pages/Status/Forbidden';
import { useWorkspace } from '../../pages/Organization/Workspace/SubmissionContexts/Users/userHook';

interface Props {
  children: JSX.Element;
  relation: string | string[];
  entityType: string;
  entityKey: string;
}

const ProtectedHOC = ({ children, relation, entityType, entityKey }: Props) => {
  const params = useParams();
  let entityId = `${params[entityKey]}`;

  const isShortname = entityKey === 'shortname';

  const {
    workspaceId = '',
    orgId = '',
    isLoadingWorkspace
  } = isShortname ? useWorkspace() : {};

  if (isShortname) {
    entityId = entityType === 'workspace' ? workspaceId : orgId;
  }

  const relations = Array.isArray(relation) ? relation : [relation];
  const accessQueries = useQueries({
    queries: relations.map(currentRelation => ({
      queryKey: [
        'auth-access',
        {
          relation: currentRelation,
          entityId,
          entityType
        }
      ],
      queryFn: () =>
        entityId
          ? getAuthAccess({
              relation: currentRelation,
              entityType,
              entityId
            })
          : null,
      retry: 0
    }))
  });

  const isLoading = accessQueries.some(query => query.isLoading);
  const isAllowed = accessQueries.some(query => query.data);

  if (isLoading || isLoadingWorkspace) return null;
  if (!isAllowed) return <Forbidden />;

  return children;
};

export default ProtectedHOC;
